//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.19.0.0 (NJsonSchema v11.0.0.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming
import * as Types from '../api-client';
import type { AxiosRequestConfig, AxiosResponse, CancelToken } from 'axios';

import { throwException, isAxiosError } from '../api-client';
import { getAxios, getBaseUrl } from './helpers';

/**
 * Gets a patient by id.
 * @param id The patient id.
 */
export function getPatient(id: string, config?: AxiosRequestConfig | undefined): Promise<Types.PatientListDto> {
    let url_ = getBaseUrl() + "/api/patients/{id}";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
      url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
        ..._requestConfigGetPatient,
        ...config,
        method: "GET",
        url: url_,
        headers: {
            "Accept": "application/json"
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processGetPatient(_response);
    });
}

function processGetPatient(response: AxiosResponse): Promise<Types.PatientListDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 400) {
        const _responseText = response.data;
        let result400: any = null;
        let resultData400  = _responseText;
        result400 = Types.ValidationProblemDetails.fromJS(resultData400);
        return throwException("Invalid request. Maybe doctor has no requested study or patient.", status, _responseText, _headers, result400);

    } else if (status === 200) {
        const _responseText = response.data;
        let result200: any = null;
        let resultData200  = _responseText;
        result200 = Types.PatientListDto.fromJS(resultData200);
        return Promise.resolve<Types.PatientListDto>(result200);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<Types.PatientListDto>(null as any);
}

/**
 * Gets a patient by study id and unique id.
 * @param studyId (optional) Study id
 * @param uniqueId (optional) Patient's unique id
 */
export function getPatientByStudyAndUniqId(studyId?: number | undefined, uniqueId?: string | undefined, config?: AxiosRequestConfig | undefined): Promise<Types.PatientListDto> {
    let url_ = getBaseUrl() + "/api/patients/byUniqId?";
    if (studyId === null)
        throw new Error("The parameter 'studyId' cannot be null.");
    else if (studyId !== undefined)
        url_ += "studyId=" + encodeURIComponent("" + studyId) + "&";
    if (uniqueId === null)
        throw new Error("The parameter 'uniqueId' cannot be null.");
    else if (uniqueId !== undefined)
        url_ += "uniqueId=" + encodeURIComponent("" + uniqueId) + "&";
      url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
        ..._requestConfigGetPatientByStudyAndUniqId,
        ...config,
        method: "GET",
        url: url_,
        headers: {
            "Accept": "application/json"
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processGetPatientByStudyAndUniqId(_response);
    });
}

function processGetPatientByStudyAndUniqId(response: AxiosResponse): Promise<Types.PatientListDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 400) {
        const _responseText = response.data;
        let result400: any = null;
        let resultData400  = _responseText;
        result400 = Types.ValidationProblemDetails.fromJS(resultData400);
        return throwException("Invalid request. Maybe doctor has no requested study or patient.", status, _responseText, _headers, result400);

    } else if (status === 200) {
        const _responseText = response.data;
        let result200: any = null;
        let resultData200  = _responseText;
        result200 = Types.PatientListDto.fromJS(resultData200);
        return Promise.resolve<Types.PatientListDto>(result200);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<Types.PatientListDto>(null as any);
}

/**
 * Get unique ids of patients in study
 * @param studyId (optional) The id of the study
 */
export function getPatientUniqueIds(studyId?: number | undefined, config?: AxiosRequestConfig | undefined): Promise<string[]> {
    let url_ = getBaseUrl() + "/api/patients/uniqueIds?";
    if (studyId === null)
        throw new Error("The parameter 'studyId' cannot be null.");
    else if (studyId !== undefined)
        url_ += "studyId=" + encodeURIComponent("" + studyId) + "&";
      url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
        ..._requestConfigGetPatientUniqueIds,
        ...config,
        method: "GET",
        url: url_,
        headers: {
            "Accept": "application/json"
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processGetPatientUniqueIds(_response);
    });
}

function processGetPatientUniqueIds(response: AxiosResponse): Promise<string[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 400) {
        const _responseText = response.data;
        let result400: any = null;
        let resultData400  = _responseText;
        result400 = Types.ValidationProblemDetails.fromJS(resultData400);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);

    } else if (status === 200) {
        const _responseText = response.data;
        let result200: any = null;
        let resultData200  = _responseText;
        if (Array.isArray(resultData200)) {
            result200 = [] as any;
            for (let item of resultData200)
                result200!.push(item);
        }
        else {
            result200 = <any>null;
        }
        return Promise.resolve<string[]>(result200);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<string[]>(null as any);
}

/**
 * Get all tags of patients in the study.
If the user is a staff of the study,
then only tags that are assigned to him will be returned.
 * @param studyId (optional) Id of the study
 */
export function getPatientTags(studyId?: number | undefined, config?: AxiosRequestConfig | undefined): Promise<{ [key: string]: string[]; }> {
    let url_ = getBaseUrl() + "/api/patients/tags?";
    if (studyId === null)
        throw new Error("The parameter 'studyId' cannot be null.");
    else if (studyId !== undefined)
        url_ += "studyId=" + encodeURIComponent("" + studyId) + "&";
      url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
        ..._requestConfigGetPatientTags,
        ...config,
        method: "GET",
        url: url_,
        headers: {
            "Accept": "application/json"
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processGetPatientTags(_response);
    });
}

function processGetPatientTags(response: AxiosResponse): Promise<{ [key: string]: string[]; }> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 400) {
        const _responseText = response.data;
        let result400: any = null;
        let resultData400  = _responseText;
        result400 = Types.ValidationProblemDetails.fromJS(resultData400);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);

    } else if (status === 200) {
        const _responseText = response.data;
        let result200: any = null;
        let resultData200  = _responseText;
        result200 = Types.TagFiltersDto.fromJS(resultData200);
        return Promise.resolve<{ [key: string]: string[]; }>(result200);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<{ [key: string]: string[]; }>(null as any);
}

/**
 * Gets all patients.
 * @param searchQuery (optional) Search query string.
e.g. Mike - return all patient which name or last name contains "Mike".
 * @param patientGroup (optional) Patient's group for paged request.
 * @param isClinic (optional) Filter patient by "clinic" status
 * @param isControlled (optional) Filter patient by "Controlled" status
 * @param needChecking (optional) Filter patient by "need check the patient" status
 * @param hasNoApp (optional) Filter patient by "No app" status
 * @param withActiveStepName (optional) Filter patient by "Route progress" step with active state
Active state is true when the RouteProgressStateEnum is InProgress or InProgressManually
 * @param withClosedStepName (optional) Filter patient by "Route progress" step with closed state
Closed state is true when the RouteProgressStateEnum is Done or Missed or Approved
 * @param tags (optional) Tags that will be used to filter patients
 * @param studyState (optional) Filter patient by "study state" status
 * @param studyId (optional) Id of study for paged request.
 * @param studyStartNotDefine (optional) Filter patient by "Study start not define" status
 * @param canBeArchived (optional) Filter patient by ready to be archived
 * @param monitoringReviewStatus (optional) Filter patient by "Monitoring review status"
 * @param offset (optional) Offset of list.
 * @param limit (optional) Number of requested records.
 * @param sortBy (optional) Field name for sorting in DB.
 * @param sortOrder (optional) Sort direction. Ascending or Descending.
 */
export function getPatients(searchQuery?: string | null | undefined, patientGroup?: number | null | undefined, isClinic?: boolean | null | undefined, isControlled?: boolean | null | undefined, needChecking?: boolean | null | undefined, hasNoApp?: boolean | null | undefined, withActiveStepName?: string | null | undefined, withClosedStepName?: string | null | undefined, tags?: { [key: string]: string[]; } | null | undefined, studyState?: Types.PatientStudyStateEnum | null | undefined, studyId?: number | undefined, studyStartNotDefine?: boolean | null | undefined, canBeArchived?: boolean | null | undefined, monitoringReviewStatus?: Types.MonitoringReviewStatusEnum | null | undefined, offset?: number | null | undefined, limit?: number | null | undefined, sortBy?: string | null | undefined, sortOrder?: Types.SortOrder | undefined, config?: AxiosRequestConfig | undefined): Promise<Types.PagedResultOfPatientListDto> {
    let url_ = getBaseUrl() + "/api/patients?";
    if (searchQuery !== undefined && searchQuery !== null)
        url_ += "SearchQuery=" + encodeURIComponent("" + searchQuery) + "&";
    if (patientGroup !== undefined && patientGroup !== null)
        url_ += "PatientGroup=" + encodeURIComponent("" + patientGroup) + "&";
    if (isClinic !== undefined && isClinic !== null)
        url_ += "IsClinic=" + encodeURIComponent("" + isClinic) + "&";
    if (isControlled !== undefined && isControlled !== null)
        url_ += "IsControlled=" + encodeURIComponent("" + isControlled) + "&";
    if (needChecking !== undefined && needChecking !== null)
        url_ += "NeedChecking=" + encodeURIComponent("" + needChecking) + "&";
    if (hasNoApp !== undefined && hasNoApp !== null)
        url_ += "HasNoApp=" + encodeURIComponent("" + hasNoApp) + "&";
    if (withActiveStepName !== undefined && withActiveStepName !== null)
        url_ += "WithActiveStepName=" + encodeURIComponent("" + withActiveStepName) + "&";
    if (withClosedStepName !== undefined && withClosedStepName !== null)
        url_ += "WithClosedStepName=" + encodeURIComponent("" + withClosedStepName) + "&";
    if (tags !== undefined && tags !== null)
    {
        const content_ = JSON.stringify(tags);
        url_ += "Tags=" + encodeURIComponent(content_) + "&";
    }
    if (studyState !== undefined && studyState !== null)
        url_ += "StudyState=" + encodeURIComponent("" + studyState) + "&";
    if (studyId === null)
        throw new Error("The parameter 'studyId' cannot be null.");
    else if (studyId !== undefined)
        url_ += "StudyId=" + encodeURIComponent("" + studyId) + "&";
    if (studyStartNotDefine !== undefined && studyStartNotDefine !== null)
        url_ += "StudyStartNotDefine=" + encodeURIComponent("" + studyStartNotDefine) + "&";
    if (canBeArchived !== undefined && canBeArchived !== null)
        url_ += "CanBeArchived=" + encodeURIComponent("" + canBeArchived) + "&";
    if (monitoringReviewStatus !== undefined && monitoringReviewStatus !== null)
        url_ += "MonitoringReviewStatus=" + encodeURIComponent("" + monitoringReviewStatus) + "&";
    if (offset !== undefined && offset !== null)
        url_ += "Offset=" + encodeURIComponent("" + offset) + "&";
    if (limit !== undefined && limit !== null)
        url_ += "Limit=" + encodeURIComponent("" + limit) + "&";
    if (sortBy !== undefined && sortBy !== null)
        url_ += "SortBy=" + encodeURIComponent("" + sortBy) + "&";
    if (sortOrder === null)
        throw new Error("The parameter 'sortOrder' cannot be null.");
    else if (sortOrder !== undefined)
        url_ += "SortOrder=" + encodeURIComponent("" + sortOrder) + "&";
      url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
        ..._requestConfigGetPatients,
        ...config,
        method: "GET",
        url: url_,
        headers: {
            "Accept": "application/json"
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processGetPatients(_response);
    });
}

function processGetPatients(response: AxiosResponse): Promise<Types.PagedResultOfPatientListDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 400) {
        const _responseText = response.data;
        let result400: any = null;
        let resultData400  = _responseText;
        result400 = Types.ValidationProblemDetails.fromJS(resultData400);
        return throwException("Invalid request. Maybe doctor has no requested study.", status, _responseText, _headers, result400);

    } else if (status === 200) {
        const _responseText = response.data;
        let result200: any = null;
        let resultData200  = _responseText;
        result200 = Types.PagedResultOfPatientListDto.fromJS(resultData200);
        return Promise.resolve<Types.PagedResultOfPatientListDto>(result200);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<Types.PagedResultOfPatientListDto>(null as any);
}

/**
 * Generates authorization code for Patient. It needs to be able to access to the app.
 */
export function generatePatientAccessCode(id: string, config?: AxiosRequestConfig | undefined): Promise<string> {
    let url_ = getBaseUrl() + "/api/patients/{id}/code";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
      url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
        ..._requestConfigGeneratePatientAccessCode,
        ...config,
        method: "POST",
        url: url_,
        headers: {
            "Accept": "application/json"
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processGeneratePatientAccessCode(_response);
    });
}

function processGeneratePatientAccessCode(response: AxiosResponse): Promise<string> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 400) {
        const _responseText = response.data;
        let result400: any = null;
        let resultData400  = _responseText;
        result400 = Types.ValidationProblemDetails.fromJS(resultData400);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);

    } else if (status === 200) {
        const _responseText = response.data;
        let result200: any = null;
        let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
        return Promise.resolve<string>(result200);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<string>(null as any);
}

/**
 * Applies new filter values for new patient.
 * @param id Id of the patient
 * @param dto Filter values DTO.
 */
export function applyFilterToPatient(id: string, dto: Types.UpdatePatientFilterDto, config?: AxiosRequestConfig | undefined): Promise<Types.PatientDto> {
    let url_ = getBaseUrl() + "/api/patients/{id}/filter";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
      url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(dto);

    let options_: AxiosRequestConfig = {
        ..._requestConfigApplyFilterToPatient,
        ...config,
        data: content_,
        method: "PATCH",
        url: url_,
        headers: {
            "Content-Type": "application/json",
            "Accept": "application/json"
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processApplyFilterToPatient(_response);
    });
}

function processApplyFilterToPatient(response: AxiosResponse): Promise<Types.PatientDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 400) {
        const _responseText = response.data;
        let result400: any = null;
        let resultData400  = _responseText;
        result400 = Types.ValidationProblemDetails.fromJS(resultData400);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);

    } else if (status === 200) {
        const _responseText = response.data;
        let result200: any = null;
        let resultData200  = _responseText;
        result200 = Types.PatientDto.fromJS(resultData200);
        return Promise.resolve<Types.PatientDto>(result200);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<Types.PatientDto>(null as any);
}

/**
 * Update tags of the patient
 * @param id Id of the patient
 * @param tags New tags
 */
export function updatePatientTags(id: string, tags: { [key: string]: string; }, config?: AxiosRequestConfig | undefined): Promise<Types.PatientDto> {
    let url_ = getBaseUrl() + "/api/patients/{id}/tags";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
      url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(tags);

    let options_: AxiosRequestConfig = {
        ..._requestConfigUpdatePatientTags,
        ...config,
        data: content_,
        method: "PATCH",
        url: url_,
        headers: {
            "Content-Type": "application/json",
            "Accept": "application/json"
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processUpdatePatientTags(_response);
    });
}

function processUpdatePatientTags(response: AxiosResponse): Promise<Types.PatientDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 400) {
        const _responseText = response.data;
        let result400: any = null;
        let resultData400  = _responseText;
        result400 = Types.ValidationProblemDetails.fromJS(resultData400);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);

    } else if (status === 200) {
        const _responseText = response.data;
        let result200: any = null;
        let resultData200  = _responseText;
        result200 = Types.PatientDto.fromJS(resultData200);
        return Promise.resolve<Types.PatientDto>(result200);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<Types.PatientDto>(null as any);
}

/**
 * Finish study for patient in non-eCRF study.
 * @param id Id of the patient
 * @param dto Finish study DTO.
 */
export function finishStudyForPatient(id: string, dto: Types.FinishPatientStudyDto, config?: AxiosRequestConfig | undefined): Promise<void> {
    let url_ = getBaseUrl() + "/api/patients/{id}/finishStudy";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
      url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(dto);

    let options_: AxiosRequestConfig = {
        ..._requestConfigFinishStudyForPatient,
        ...config,
        data: content_,
        method: "POST",
        url: url_,
        headers: {
            "Content-Type": "application/json",
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processFinishStudyForPatient(_response);
    });
}

function processFinishStudyForPatient(response: AxiosResponse): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 400) {
        const _responseText = response.data;
        let result400: any = null;
        let resultData400  = _responseText;
        result400 = Types.ValidationProblemDetails.fromJS(resultData400);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);

    } else if (status === 200) {
        const _responseText = response.data;
        return Promise.resolve<void>(null as any);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<void>(null as any);
}

/**
 * Archive the patient
 * @param id Id of the patient
 */
export function archivePatient(id: string, config?: AxiosRequestConfig | undefined): Promise<void> {
    let url_ = getBaseUrl() + "/api/patients/{id}/archive";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
      url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
        ..._requestConfigArchivePatient,
        ...config,
        method: "POST",
        url: url_,
        headers: {
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processArchivePatient(_response);
    });
}

function processArchivePatient(response: AxiosResponse): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 400) {
        const _responseText = response.data;
        let result400: any = null;
        let resultData400  = _responseText;
        result400 = Types.ValidationProblemDetails.fromJS(resultData400);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);

    } else if (status === 200) {
        const _responseText = response.data;
        return Promise.resolve<void>(null as any);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<void>(null as any);
}

/**
 * Check is finish study allowed for patient.
 * @param id Id of the patient
 */
export function isFinishStudyAllowed(id: string, config?: AxiosRequestConfig | undefined): Promise<boolean> {
    let url_ = getBaseUrl() + "/api/patients/{id}/isFinishStudyAllowed";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
      url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
        ..._requestConfigIsFinishStudyAllowed,
        ...config,
        method: "GET",
        url: url_,
        headers: {
            "Accept": "application/json"
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processIsFinishStudyAllowed(_response);
    });
}

function processIsFinishStudyAllowed(response: AxiosResponse): Promise<boolean> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 400) {
        const _responseText = response.data;
        let result400: any = null;
        let resultData400  = _responseText;
        result400 = Types.ValidationProblemDetails.fromJS(resultData400);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);

    } else if (status === 200) {
        const _responseText = response.data;
        let result200: any = null;
        let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
        return Promise.resolve<boolean>(result200);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<boolean>(null as any);
}

export function getPatientStudyCounters(studyId: number, config?: AxiosRequestConfig | undefined): Promise<Types.PatientGroupCountersDto[]> {
    let url_ = getBaseUrl() + "/api/patients/{studyId}/counters";
    if (studyId === undefined || studyId === null)
      throw new Error("The parameter 'studyId' must be defined.");
    url_ = url_.replace("{studyId}", encodeURIComponent("" + studyId));
      url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
        ..._requestConfigGetPatientStudyCounters,
        ...config,
        method: "GET",
        url: url_,
        headers: {
            "Accept": "application/json"
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processGetPatientStudyCounters(_response);
    });
}

function processGetPatientStudyCounters(response: AxiosResponse): Promise<Types.PatientGroupCountersDto[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 400) {
        const _responseText = response.data;
        let result400: any = null;
        let resultData400  = _responseText;
        result400 = Types.ValidationProblemDetails.fromJS(resultData400);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);

    } else if (status === 200) {
        const _responseText = response.data;
        let result200: any = null;
        let resultData200  = _responseText;
        if (Array.isArray(resultData200)) {
            result200 = [] as any;
            for (let item of resultData200)
                result200!.push(Types.PatientGroupCountersDto.fromJS(item));
        }
        else {
            result200 = <any>null;
        }
        return Promise.resolve<Types.PatientGroupCountersDto[]>(result200);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<Types.PatientGroupCountersDto[]>(null as any);
}

/**
 * Return information with related reason of update for requested patientId
 * @param id (optional) Patient's Id
 */
export function getPatientChangesInfo(id?: string | undefined, config?: AxiosRequestConfig | undefined): Promise<Types.PatientChangesDetails> {
    let url_ = getBaseUrl() + "/api/patients/changes?";
    if (id === null)
        throw new Error("The parameter 'id' cannot be null.");
    else if (id !== undefined)
        url_ += "id=" + encodeURIComponent("" + id) + "&";
      url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
        ..._requestConfigGetPatientChangesInfo,
        ...config,
        method: "GET",
        url: url_,
        headers: {
            "Accept": "application/json"
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processGetPatientChangesInfo(_response);
    });
}

function processGetPatientChangesInfo(response: AxiosResponse): Promise<Types.PatientChangesDetails> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 400) {
        const _responseText = response.data;
        let result400: any = null;
        let resultData400  = _responseText;
        result400 = Types.ValidationProblemDetails.fromJS(resultData400);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);

    } else if (status === 200) {
        const _responseText = response.data;
        let result200: any = null;
        let resultData200  = _responseText;
        result200 = Types.PatientChangesDetails.fromJS(resultData200);
        return Promise.resolve<Types.PatientChangesDetails>(result200);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<Types.PatientChangesDetails>(null as any);
}

/**
 * Return list of devices which are assigned to patient
 * @param id Patient's Id
 */
export function getPatientDeviceBindings(id: string, config?: AxiosRequestConfig | undefined): Promise<Types.DeviceBindingDto[]> {
    let url_ = getBaseUrl() + "/api/patients/{id}/deviceBindings";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
      url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
        ..._requestConfigGetPatientDeviceBindings,
        ...config,
        method: "GET",
        url: url_,
        headers: {
            "Accept": "application/json"
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processGetPatientDeviceBindings(_response);
    });
}

function processGetPatientDeviceBindings(response: AxiosResponse): Promise<Types.DeviceBindingDto[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 400) {
        const _responseText = response.data;
        let result400: any = null;
        let resultData400  = _responseText;
        result400 = Types.ValidationProblemDetails.fromJS(resultData400);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);

    } else if (status === 200) {
        const _responseText = response.data;
        let result200: any = null;
        let resultData200  = _responseText;
        if (Array.isArray(resultData200)) {
            result200 = [] as any;
            for (let item of resultData200)
                result200!.push(Types.DeviceBindingDto.fromJS(item));
        }
        else {
            result200 = <any>null;
        }
        return Promise.resolve<Types.DeviceBindingDto[]>(result200);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<Types.DeviceBindingDto[]>(null as any);
}

/**
 * Review patient by id
 * @param id Id of the patient
 */
export function reviewPatient(id: string, config?: AxiosRequestConfig | undefined): Promise<void> {
    let url_ = getBaseUrl() + "/api/patients/{id}/review";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
      url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
        ..._requestConfigReviewPatient,
        ...config,
        method: "POST",
        url: url_,
        headers: {
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processReviewPatient(_response);
    });
}

function processReviewPatient(response: AxiosResponse): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 400) {
        const _responseText = response.data;
        let result400: any = null;
        let resultData400  = _responseText;
        result400 = Types.ValidationProblemDetails.fromJS(resultData400);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);

    } else if (status === 200) {
        const _responseText = response.data;
        return Promise.resolve<void>(null as any);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<void>(null as any);
}

/**
 * Revoke review for patient by id
 */
export function revokePatientReview(id: string, config?: AxiosRequestConfig | undefined): Promise<void> {
    let url_ = getBaseUrl() + "/api/patients/{id}/revokeReview";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
      url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
        ..._requestConfigRevokePatientReview,
        ...config,
        method: "POST",
        url: url_,
        headers: {
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processRevokePatientReview(_response);
    });
}

function processRevokePatientReview(response: AxiosResponse): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 400) {
        const _responseText = response.data;
        let result400: any = null;
        let resultData400  = _responseText;
        result400 = Types.ValidationProblemDetails.fromJS(resultData400);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);

    } else if (status === 200) {
        const _responseText = response.data;
        return Promise.resolve<void>(null as any);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<void>(null as any);
}
let _requestConfigGetPatient: Partial<AxiosRequestConfig> | null;
export function getGetPatientRequestConfig() {
  return _requestConfigGetPatient;
}
export function setGetPatientRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigGetPatient = value;
}
export function patchGetPatientRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigGetPatient = patch(_requestConfigGetPatient ?? {});
}

let _requestConfigGetPatientByStudyAndUniqId: Partial<AxiosRequestConfig> | null;
export function getGetPatientByStudyAndUniqIdRequestConfig() {
  return _requestConfigGetPatientByStudyAndUniqId;
}
export function setGetPatientByStudyAndUniqIdRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigGetPatientByStudyAndUniqId = value;
}
export function patchGetPatientByStudyAndUniqIdRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigGetPatientByStudyAndUniqId = patch(_requestConfigGetPatientByStudyAndUniqId ?? {});
}

let _requestConfigGetPatientUniqueIds: Partial<AxiosRequestConfig> | null;
export function getGetPatientUniqueIdsRequestConfig() {
  return _requestConfigGetPatientUniqueIds;
}
export function setGetPatientUniqueIdsRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigGetPatientUniqueIds = value;
}
export function patchGetPatientUniqueIdsRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigGetPatientUniqueIds = patch(_requestConfigGetPatientUniqueIds ?? {});
}

let _requestConfigGetPatientTags: Partial<AxiosRequestConfig> | null;
export function getGetPatientTagsRequestConfig() {
  return _requestConfigGetPatientTags;
}
export function setGetPatientTagsRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigGetPatientTags = value;
}
export function patchGetPatientTagsRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigGetPatientTags = patch(_requestConfigGetPatientTags ?? {});
}

let _requestConfigGetPatients: Partial<AxiosRequestConfig> | null;
export function getGetPatientsRequestConfig() {
  return _requestConfigGetPatients;
}
export function setGetPatientsRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigGetPatients = value;
}
export function patchGetPatientsRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigGetPatients = patch(_requestConfigGetPatients ?? {});
}

let _requestConfigGeneratePatientAccessCode: Partial<AxiosRequestConfig> | null;
export function getGeneratePatientAccessCodeRequestConfig() {
  return _requestConfigGeneratePatientAccessCode;
}
export function setGeneratePatientAccessCodeRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigGeneratePatientAccessCode = value;
}
export function patchGeneratePatientAccessCodeRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigGeneratePatientAccessCode = patch(_requestConfigGeneratePatientAccessCode ?? {});
}

let _requestConfigApplyFilterToPatient: Partial<AxiosRequestConfig> | null;
export function getApplyFilterToPatientRequestConfig() {
  return _requestConfigApplyFilterToPatient;
}
export function setApplyFilterToPatientRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigApplyFilterToPatient = value;
}
export function patchApplyFilterToPatientRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigApplyFilterToPatient = patch(_requestConfigApplyFilterToPatient ?? {});
}

let _requestConfigUpdatePatientTags: Partial<AxiosRequestConfig> | null;
export function getUpdatePatientTagsRequestConfig() {
  return _requestConfigUpdatePatientTags;
}
export function setUpdatePatientTagsRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigUpdatePatientTags = value;
}
export function patchUpdatePatientTagsRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigUpdatePatientTags = patch(_requestConfigUpdatePatientTags ?? {});
}

let _requestConfigFinishStudyForPatient: Partial<AxiosRequestConfig> | null;
export function getFinishStudyForPatientRequestConfig() {
  return _requestConfigFinishStudyForPatient;
}
export function setFinishStudyForPatientRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigFinishStudyForPatient = value;
}
export function patchFinishStudyForPatientRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigFinishStudyForPatient = patch(_requestConfigFinishStudyForPatient ?? {});
}

let _requestConfigArchivePatient: Partial<AxiosRequestConfig> | null;
export function getArchivePatientRequestConfig() {
  return _requestConfigArchivePatient;
}
export function setArchivePatientRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigArchivePatient = value;
}
export function patchArchivePatientRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigArchivePatient = patch(_requestConfigArchivePatient ?? {});
}

let _requestConfigIsFinishStudyAllowed: Partial<AxiosRequestConfig> | null;
export function getIsFinishStudyAllowedRequestConfig() {
  return _requestConfigIsFinishStudyAllowed;
}
export function setIsFinishStudyAllowedRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigIsFinishStudyAllowed = value;
}
export function patchIsFinishStudyAllowedRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigIsFinishStudyAllowed = patch(_requestConfigIsFinishStudyAllowed ?? {});
}

let _requestConfigGetPatientStudyCounters: Partial<AxiosRequestConfig> | null;
export function getGetPatientStudyCountersRequestConfig() {
  return _requestConfigGetPatientStudyCounters;
}
export function setGetPatientStudyCountersRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigGetPatientStudyCounters = value;
}
export function patchGetPatientStudyCountersRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigGetPatientStudyCounters = patch(_requestConfigGetPatientStudyCounters ?? {});
}

let _requestConfigGetPatientChangesInfo: Partial<AxiosRequestConfig> | null;
export function getGetPatientChangesInfoRequestConfig() {
  return _requestConfigGetPatientChangesInfo;
}
export function setGetPatientChangesInfoRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigGetPatientChangesInfo = value;
}
export function patchGetPatientChangesInfoRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigGetPatientChangesInfo = patch(_requestConfigGetPatientChangesInfo ?? {});
}

let _requestConfigGetPatientDeviceBindings: Partial<AxiosRequestConfig> | null;
export function getGetPatientDeviceBindingsRequestConfig() {
  return _requestConfigGetPatientDeviceBindings;
}
export function setGetPatientDeviceBindingsRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigGetPatientDeviceBindings = value;
}
export function patchGetPatientDeviceBindingsRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigGetPatientDeviceBindings = patch(_requestConfigGetPatientDeviceBindings ?? {});
}

let _requestConfigReviewPatient: Partial<AxiosRequestConfig> | null;
export function getReviewPatientRequestConfig() {
  return _requestConfigReviewPatient;
}
export function setReviewPatientRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigReviewPatient = value;
}
export function patchReviewPatientRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigReviewPatient = patch(_requestConfigReviewPatient ?? {});
}

let _requestConfigRevokePatientReview: Partial<AxiosRequestConfig> | null;
export function getRevokePatientReviewRequestConfig() {
  return _requestConfigRevokePatientReview;
}
export function setRevokePatientReviewRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigRevokePatientReview = value;
}
export function patchRevokePatientReviewRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigRevokePatientReview = patch(_requestConfigRevokePatientReview ?? {});
}